export default __webpack_public_path__ + "assets/webgl/picking-2.8b76d9f0.glb";